

if (document.getElementById("env") != null) document.getElementById("env").addEventListener("click", env);
if (document.getElementById("dev") != null)	document.getElementById("dev").addEventListener("click", env);

	function env() {
  	
  var dev = document.getElementById("dev");
  var env = document.getElementById("env");
  dev.classList.toggle("edselected");
  env.classList.toggle("edselected");
  
  
  var pdesc = document.getElementById("producto-desc");
  var penv = document.getElementById("producto-ed");
  pdesc.classList.toggle("invisible");
  penv.classList.toggle("invisible");
  
  
};

var qs = (function(a) {
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i)
    {
        var p=a[i].split('=', 2);
        if (p.length == 1)
            b[p[0]] = "";
        else
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
})(window.location.search.substr(1).split('&'));
        

if (qs["contact_posted"] == "true"){
  var fs = document.getElementById("form-success");

  fs.classList.toggle("hidden");

}


